export const getDesktopUrl = (): string => {
  const { hostname } = window.location;
  const desktopHost = hostname.startsWith('m.') ? hostname.substring(2) : hostname;
  return `//${desktopHost}?desktop=true`;
};
